import { ErrorResponseErrorItemCodeSharedView } from '../../../../typings/api/skymap/rest/v1/.common';

export const translations: Record<ErrorResponseErrorItemCodeSharedView, string> = {
  'shared_view:comment_not_found': 'Kommentaren kunde inte hittas.',
  'shared_view:dynamic_asset_not_found': 'Objektet är inte kopplat till den delade vyn',
  'shared_view:file_not_found': 'Filen kunde inte hittas.',
  'shared_view:file_version_not_found': 'Filversionen kunde inte hittas.',
  'shared_view:not_found': 'Den delade vyn kunde inte hittas.',
};
